import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IApp } from "@core/models/app.interfaces";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
const DISPLAY_ACTION_BUTTONS_PROP = 'display.action.buttons';
const SESSION_INACTIVITY_TIME_PROP = 'session.inactive.validity.time';
const UI_DATE_REVISED_PROP = 'ui.date.revised';
const TRANSLATION_PREFIX_IGNORE_PROPERTY = 'application.ignoreTranslationPrefix';
const REGISTRY_SERVER_COMBINED_PROPERTY = '/registry-server/property/getPropertiesByKeys?keys=';



@Injectable({
    providedIn: 'root'
})

export class CombinedPropertyService {

    constructor(
        private http: HttpClient,
    ) { }

    combinedServiceCall() {
        const propertyCombined = DISPLAY_ACTION_BUTTONS_PROP + ',' + UI_DATE_REVISED_PROP + ',' +
            TRANSLATION_PREFIX_IGNORE_PROPERTY + ',' + SESSION_INACTIVITY_TIME_PROP ;
        return this.getCombinedProperty(propertyCombined);
    }

    getCombinedProperty(propertyName: string): Observable<IApp.Property> {
        let propertyUrl = REGISTRY_SERVER_COMBINED_PROPERTY;
        return this.http.get<IApp.Property>(`${environment.apiUrl}${propertyUrl}${propertyName}`)
            .pipe(
                map(data => {
                    return data;
                }),
            );
    }
}